export default __webpack_public_path__ + "static/char-13-anr-8fe407fb61888fae9bfd450453164106.webp";